module.exports = __webpack_public_path__ + "static/media/AW_56_Burger_mobile_hero_en.eb40e037.jpg";